import { Link } from 'react-router-dom';

export default function About() {
  return (
    <div>
      <section className="pad-x" style={{ padding: '80px 40px 80px', maxWidth: 600 }}>
        <div
          style={{
            fontSize: 11,
            fontWeight: 600,
            letterSpacing: '0.14em',
            color: 'var(--tag)',
            marginBottom: 24,
            textTransform: 'uppercase',
          }}
        >
          About
        </div>
        <h1
          className="hero-title"
          style={{
            fontSize: 44,
            fontWeight: 700,
            letterSpacing: '-0.03em',
            lineHeight: 1.1,
            marginBottom: 32,
          }}
        >
          Excuses, without
          <br />
          the guilt.
        </h1>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 20,
            color: 'var(--fg-muted)',
            fontSize: 15,
            lineHeight: 1.75,
          }}
        >
          <p>
            ImNotGoing started as a simple idea: most people are terrible at
            saying no. Not because they want to go to things — they don't — but
            because they can't find the right words that feel honest without
            feeling awful.
          </p>
          <p>
            The tool generates three types of excuse per situation. The Soft
            Boundary is professional and restrained. The Personal Truth is
            honest and slightly self-aware. The Chaos Card is usefully vague.
          </p>
          <p>
            None of them are lies. They're all true in some version of events.
            That's the point.
          </p>
        </div>
        <div style={{ marginTop: 48 }}>
          <Link
            to="/"
            style={{
              padding: '14px 28px',
              background: 'var(--accent)',
              borderRadius: 6,
              fontSize: 14,
              fontWeight: 600,
              color: '#0f0f0f',
              textDecoration: 'none',
            }}
          >
            Start generating →
          </Link>
        </div>
      </section>

      <footer
        className="pad-x"
        style={{
          borderTop: '1px solid var(--border)',
          padding: '20px 40px',
        }}
      >
        <span
          style={{ fontSize: 13, color: 'var(--tag)', fontStyle: 'italic' }}
        >
          "You're not flaky. You're just honest about your limits."
        </span>
      </footer>
    </div>
  );
}
